export const RankXP = [
  0, 10000, 20000, 40000, 80000, 160000, 196800, 242100, 297700, 366200, 450400,
  554100, 681500, 838200, 1081300, 1394900, 1799400, 2321200, 2994400, 3862800,
  4983000, 6428000, 8292200, 10696900, 13799000, 17800700, 22962900, 29622200,
  38212600, 49294200,
];

export const RankXPName = [
  "Nobody",
  "Apprentice",
  "Pickpocket",
  "Cloak",
  "Thief",
  "Locksmith",
  "Runner",
  "Associate",
  "Dealer",
  "Fixer",
  "Collector",
  "Enforcer",
  "Prospect",
  "Lieutenant",
  "Soldier",
  "Mobster",
  "Swindler",
  "Whisperer",
  "Architect",
  "Hitman",
  "Assassin",
  "Commander",
  "Executioner",
  "Widowmaker",
  "Bone collector",
  "Tactician",
  "Chief",
  "Warlord",
  "Capo bastone",
  "Godfather",
];
